export default "__VITE_ASSET__esY6GNqa__"